import { render, staticRenderFns } from "./tabs-Names.vue?vue&type=template&id=dfb4aebc&scoped=true&"
import script from "./tabs-Names.vue?vue&type=script&lang=js&"
export * from "./tabs-Names.vue?vue&type=script&lang=js&"
import style0 from "./tabs-Names.vue?vue&type=style&index=0&id=dfb4aebc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb4aebc",
  null
  
)

export default component.exports